import type {FC} from 'react';
import {useEffect} from 'react';
import {BridgeEventSources, Events} from '@wellstone-solutions/common';
import {useEventSource} from 'hooks/useEventSource';
import {useStores} from 'hooks/useStores';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {TabbedPage} from 'components/TabbedPage';
import type {TabbedPageTab, TabbedPageTabs} from 'components/TabbedPage';
import {PAGE_DESCRIPTION} from '../../constants';
import {NewSessionDocumentButton} from './NewSessionDocumentButton';
import {NewNoteButton} from './NewNoteButton';

const SESSION_DOCUMENTS_TAB: TabbedPageTab = {
  path: '/documentation',
  label: 'Session Documentation',
  ActionButton: NewSessionDocumentButton,
};

const NOTES_TAB: TabbedPageTab = {
  path: '/documentation/notes',
  label: 'Notes',
  title: 'Notes',
  description: 'View and create notes about your contacts with members.',
  ActionButton: NewNoteButton,
};

const ALL_TABS: TabbedPageTabs = [SESSION_DOCUMENTS_TAB, NOTES_TAB];
const NOTES_ONLY_TABS: TabbedPageTabs = [NOTES_TAB];

export const DocumentationTabsRoot: FC = () => {
  const {appUIStore, eventStore} = useStores();
  const hasSessionDocumentation = useFeatureFlag(LD_FLAGS.PEERS_DOCUMENTATION);

  //Picks which tabs to render only; AuthorizedRoutes determines which feature is enabled
  const tabs = hasSessionDocumentation ? ALL_TABS : NOTES_ONLY_TABS;

  useEventSource(BridgeEventSources.DOCUMENTATION_PAGE);

  useEffect(() => {
    appUIStore.setBreadcrumbs([]);
    eventStore.addEvent(Events.VIEWED_DOCUMENTATION);
  }, [appUIStore, eventStore]);

  return (
    <TabbedPage tabs={tabs}>
      <TabbedPage.Header title="Documentation" description={PAGE_DESCRIPTION} />
      <TabbedPage.TabBar ariaLabel="Documentation tabs" />
      <TabbedPage.Content />
    </TabbedPage>
  );
};
